import { useState } from "react";
import useLangStore from "store/langStore";
import imgEs from "src/assets/apps/es.png";
import imgEn from "src/assets/apps/en.png";
import imgFr from "src/assets/apps/fr.png";
import imgPt from "src/assets/apps/pt.png";
import imgZh from "src/assets/apps/zh.png";
import { ArrowDownIcon } from "components/Icons";

const LANGS = [
  { name: "es", img: imgEs },
  { name: "en", img: imgEn },
  { name: "fr", img: imgFr },
  { name: "pt", img: imgPt },
  { name: "zh", img: imgZh },
];

const ChangeLang = () => {
  const { changeLang, locale } = useLangStore();
  const currentLang = LANGS.find((lang) => lang.name === locale);
  const [open, setOpen] = useState(false);

  const handleLanguageChange = (lang) => {
    changeLang(lang);
    setOpen(false);
  };

  return (
    <div className="relative text-white bg-neutral-700 rounded-sm h-8">
      <div
        className="flex items-center justify-between cursor-pointer p-1 w-22 border-none"
        onClick={() => setOpen(!open)}
      >
        <img
          src={currentLang.img}
          alt={currentLang.name}
          className="size-4 mx-1"
        />
        <span>{currentLang.name}</span>
        <ArrowDownIcon className="size-5" />
      </div>

      {open && (
        <div className="absolute z-10 w-full bg-white shadow  ">
          {LANGS.map((lang) => (
            <div
              className="flex items-center p-1 cursor-pointer hover:bg-gray-600 bg-gray-800 text-sm p-2 "
              onClick={() => handleLanguageChange(lang.name)}
            >
              <img src={lang.img} alt={lang.name} className="size-4 mr-2" />
              <span>{lang.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChangeLang;
